import * as actionTypes from '../actions/actionTypes';

const initialState = {
  token: null,
  userId: null,
  error: null,
  errorCode: null,
  loading: false,
  email: '',
  password: '',
  authRedirectPath: '/home',
  isAdmin: false,
  userIdCode: null,
  userCountry: null,
  userExtension: null,
  userTimeZone: 'Europe/Dublin',
  billingType: null,
  smsBillingType: null,
  smsSenderName: null,
  /**
   * @deprecated This method will be removed in v1.26.0 as conversation feature deprecated SendSMS component.
   */
  smsSenderNames: null,
  accountBalance: null,
  smsBalance: null,
  smsBillPayRate: null,
  userPermissions: null,
  company_name: null,
  user_name: null,
  account_id: null,
  outbound_cli: null,
  user_extension: null,
  account_name: null,
  user_shared_accounts: [],
  twoFactorInfo: {
    isEnabled: false,
    userId: null,
    email: null,
    name: null,
  },
  revokeRequested: false,
  passExpirationReqs: null,
};

const reducer = (state = initialState, action) => {
  let twoFactorInfo = null;

  switch (action.type) {
    case actionTypes.AUTH_START:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case actionTypes.TWO_FACTOR_AUTH_START:
      twoFactorInfo = {
        ...state.twoFactorInfo,
        ...action.twoFactorInfo,
      };
      return {
        ...state,
        loading: true,
        twoFactorInfo,
      };
    case actionTypes.TWO_FACTOR_AUTH_RESET:
      twoFactorInfo = {
        ...state.twoFactorInfo,
        ...action.twoFactorInfo,
      };
      return {
        ...state,
        loading: false,
        twoFactorInfo,
      };
    case actionTypes.SET_NEW_PASSWORD_REQUIREMENTS:
      return {
        ...state,
        passExpirationReqs: action.requirements,
      };
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        token: action.token,
        userId: action.userId,
        userExtension: action.userExtension,
        isAdmin: action.isAdmin,
        userPermissions: action.userPermissions,
        error: null,
        loading: false,
      };
    case actionTypes.AUTH_LOGOUT:
      return {
        ...state,
        token: null,
        userId: null,
      };
    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
        loading: false,
      };
    case actionTypes.SET_USER_COUNTRY:
      return {
        ...state,
        userCountry: action.userCountry,
        userExtension: action.userExtension,
        userTimeZone: action.userTimeZone,
      };
    case actionTypes.SET_AUTH_REDIRECT_PATH:
      return {
        ...state,
        authRedirectPath: action.path,
      };
    case actionTypes.SET_USER_EXTENSION:
      return {
        ...state,
        user_extension: action.payload.userExtension,
        userExtension: action.payload.userExtension,
      };
    case actionTypes.SET_AUTH_USER_EMAIL:
      return {
        ...state,
        email: action.email,
      };
    case actionTypes.SET_AUTH_USER_PASSWORD:
      return {
        ...state,
        password: action.password,
      };
    case actionTypes.SET_AUTH_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case actionTypes.SET_ACCOUNT_INFO:
      return {
        ...state,
        billingType: action.billingType,
        smsBillingType: action.smsBillingType,
        accountBalance: action.accountBalance,
        smsBalance: action.smsBalance,
        smsBillPayRate: action.smsBillPayRate,
        smsSenderName: action.smsSenderName,
        smsSenderNames: action.smsSenderNames,
        isAdmin: action.isAdmin,
        userIdCode: action.userIdCode,
        company_name: action.company_name,
        user_name: action.user_name,
        account_id: action.account_id,
        outbound_cli: action.outbound_cli,
        user_extension: action.user_extension,
        account_name: action.account_name,
        user_shared_accounts: action.user_shared_accounts,
      };
    case actionTypes.SET_SESSION_REVOKE_REQUESTED:
      return {
        ...state,
        revokeRequested: true,
      };
    case actionTypes.AUTH_RESET:
      return {
        ...initialState,
        email: action.payload.keepEmail ? state.email : '',
      };
    default:
      return state;
  }
};

export default reducer;
